"use client";

import { createContext, useContext, type ReactNode } from "react";
import { useAuthStore } from "@/store/auth.store";
import { useCustomerOrdersSSE, type OrderSSEState } from "@/hooks/use-order-sse";

type LiveOrdersMap = Record<string, OrderSSEState>;

const LiveOrdersContext = createContext<LiveOrdersMap>({});

/**
 * Mounts the customer-orders SSE stream once for the whole app. Backed by the
 * SharedWorker, so this single subscription reuses one upstream connection
 * across every page and tab. Place it high in the authenticated layout.
 */
export function OrdersSSEProvider({ children }: { children: ReactNode }) {
  const user = useAuthStore((s) => s.user);
  const liveOrders = useCustomerOrdersSSE(!!user);
  return <LiveOrdersContext.Provider value={liveOrders}>{children}</LiveOrdersContext.Provider>;
}

/** Live order status/location map keyed by order ULID, streamed via SSE. */
export function useLiveOrders(): LiveOrdersMap {
  return useContext(LiveOrdersContext);
}
